import Index from './Index.vue';

export default {
  path: 'relatorio/vendas/vendedores',
  name: 'relatorio-vendas-vendedores',
  component: Index,
};
